module.exports = __webpack_public_path__ + "img/logo_consorcio_preto.31c192c2.png";